<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>解锁配置</span>
          <!--          <el-button v-permisaction="['config:unlockLevel:uploadCdn']" :loading="loading" size="mini" style="margin-left: 10px" type="primary" @click="uploadCdn()">同步到S3</el-button>-->
          <syncVersion :in-method="uploadCdn" :params="params" />

        </div>
        <el-form class="demo-form-inline">
          <el-form-item label="每日签到">
            <el-input v-model.number="formData.signIn" style="width: 300px;" placeholder="每日签到" />
          </el-form-item>
          <el-form-item label="自动转">
            <el-input v-model.number="formData.autoDice" style="width: 300px;" placeholder="自动转" />
          </el-form-item>
          <el-form-item label="bet">
            <el-input v-model.number="formData.bet" style="width: 300px;" placeholder="倍率" />
          </el-form-item>
          <el-form-item label="卡片系统">
            <el-input v-model.number="formData.gift" style="width: 300px;" placeholder="卡片系统" />
          </el-form-item>
          <el-form-item label="每日任务">
            <el-input v-model.number="formData.dailyTask" style="width: 300px;" placeholder="每日任务" />
          </el-form-item>
          <el-form-item label="野兽开放等级">
            <el-input v-model.number="formData.beastCoinOpenLevel" style="width: 300px;" placeholder="野兽开放等级" />
          </el-form-item>
          <el-button v-permisaction="['config:unlockLevel:update']" type="primary" @click="onSubmit()">保存</el-button>
        </el-form>
      </el-card>

      <el-card class="box-card">
        <Teaser />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getCommonCfg, updateCommonCfg, uploadCdn } from '@/api/config/common-cfg'
import Teaser from '@/views/config/unlock-level/components/teaser.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'

export default {
  name: 'UnlockLevel',
  components: {
    SyncVersion,
    Teaser
  },
  data() {
    return {
      loading: false,
      params: { name: 'unlockLevel', type: 'unlockLevel' },
      formData:
        {
          'signIn': 0,
          'autoDice': 0,
          'bet': 0,
          'gift': 0,
          'dailyTask': 0,
          'club': 0,
          'beastCoinOpenLevel': 0
        }
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    uploadCdn,
    onSubmit() {
      const data = JSON.stringify(this.formData)
      updateCommonCfg({ name: 'unlockLevel', data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getCommonCfg({ name: 'unlockLevel' }).then(res => {
        this.formData = res.data
      })
    }
    // uploadCdn() {
    //   this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     this.loading = true
    //     uploadCdn({ name: 'unlockLevel', type: 'unlockLevel' }).then(res => {
    //       this.loading = false
    //       if (res.code === 200) {
    //         this.msgSuccess(res.msg)
    //         this.getTables(name)
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // }
  }
}
</script>

<style scoped>
</style>
